<app-spinner-global></app-spinner-global>
<router-outlet />
